module.exports = __webpack_public_path__ + "static/media/accessory_03.4a85d767.jpg";